import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Calendar16 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={16}
    contrast={contrast}
    className={className}
  >
    <path
      d='M4.5 7.5C5.05228 7.5 5.5 7.05228 5.5 6.5C5.5 5.94772 5.05228 5.5 4.5 5.5C3.94772 5.5 3.5 5.94772 3.5 6.5C3.5 7.05228 3.94772 7.5 4.5 7.5Z'
      fill='currentColor'
    />
    <path
      d='M5.5 10C5.5 10.5523 5.05228 11 4.5 11C3.94772 11 3.5 10.5523 3.5 10C3.5 9.44771 3.94772 9 4.5 9C5.05228 9 5.5 9.44771 5.5 10Z'
      fill='currentColor'
    />
    <path
      d='M8 7.5C8.55228 7.5 9 7.05228 9 6.5C9 5.94772 8.55228 5.5 8 5.5C7.44772 5.5 7 5.94772 7 6.5C7 7.05228 7.44772 7.5 8 7.5Z'
      fill='currentColor'
    />
    <path
      d='M9 10C9 10.5523 8.55228 11 8 11C7.44772 11 7 10.5523 7 10C7 9.44771 7.44772 9 8 9C8.55228 9 9 9.44771 9 10Z'
      fill='currentColor'
    />
    <path
      d='M11.5 7.5C12.0523 7.5 12.5 7.05228 12.5 6.5C12.5 5.94772 12.0523 5.5 11.5 5.5C10.9477 5.5 10.5 5.94772 10.5 6.5C10.5 7.05228 10.9477 7.5 11.5 7.5Z'
      fill='currentColor'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M12.25 1.75H14.5625C15.1944 1.75 15.75 2.2517 15.75 2.92308V13.0769C15.75 13.7483 15.1944 14.25 14.5625 14.25H1.4375C0.805559 14.25 0.25 13.7483 0.25 13.0769V2.92308C0.25 2.2517 0.805559 1.75 1.4375 1.75H3.75V0.5H5.25V1.75H10.75V0.5H12.25V1.75ZM3.75 3.25V4H5.25V3.25H10.75V4H12.25V3.25H14.25V12.75H1.75V3.25H3.75Z'
      fill='currentColor'
    />
  </Svg>
);

Calendar16.displayName = 'Calendar16';
export default Calendar16;
